export default {
    'menu.welcome': 'Mirëserdhe',
    'menu.more-blocks': 'Më shumë blloqe',
    'menu.home': 'Shtëpi',
    'menu.admin': 'Admin',
    'menu.admin.sub-page': 'Nën-faqe',
    'menu.login': 'Hyrja',
    'menu.register': 'Regjistrohu',
    'menu.register-result': 'Rezultati i regjistrimit',
    'menu.dashboard': 'Kryefaqja',
    'menu.dashboard.overview': 'Gjeneral',
    'menu.dashboard.analytic': 'Analitike',
    'menu.dashboard.financial': 'Financiare',

    'menu.mvl': 'MVL',
    'menu.hm': 'HM',
    'menu.cargo-in-transit': 'Malli ne transport',
    'menu.cmr': 'CMR',
    'menu.pi': 'PI',
    'menu.aviation-casco': 'Aviacion Casco',
    'menu.aviation-tpl': 'Aviacion TPL',

    'menu.motor': 'Motor',
    'menu.motor.sales': 'Shitjet',
    'menu.motor.sales.new': 'Shitjet e reja',
    'menu.motor.sales.new.tpl': 'TPL',
    'menu.motor.sales.new.casco': 'Kasko',
    'menu.motor.sales.new.other': 'Tjetër',
    'menu.motor.sales.list': 'Listë',
    'menu.motor.sales.lista-e-drafteve': 'Lista e drafteve',
    'menu.motor.sales.renewals': 'Rinovime',
    'menu.motor.claims': 'Pretendimet',
    'menu.motor.claims.new': 'Praktikë e re',
    'menu.motor.claims.list': 'Lista e kërkesave',
    'menu.motor.claims.list-events': 'Lista e ngjarjeve',
    'menu.motor.configurations': 'Konfigurimet',
    'menu.motor.configurations.fleets': 'Flotat',
    'menu.casco': 'Kasko',
    'menu.daily-casco': 'Kasko ditore',
    'menu.minicasco': 'Mini Kasko',
    'menu.fpp': 'FPP',
    'menu.tpl': 'TPL',
    'menu.tpl-v1': 'TPL e vjeter',
    'menu.green_card': 'Kartoni jeshil',
    'menu.border': 'Kufitarja',
    'menu.passenger': 'Pasagjerët',
    'menu.new': 'I ri',
    'menu.new.new': 'Police e re',
    'menu.professional': 'Profesionist',
    'menu.new.professional': 'Profesionist',
    'menu.autosos': 'Autosos',

    'menu.property': 'Prona',
    'menu.property.sales': 'Shitjet',
    'menu.property.sales.new': 'Shitjet e reja',
    'menu.property.sales.new.fire': 'Zjarr',
    'menu.property.sales.new.liability': 'Përgjegjësia',
    'menu.property.sales.new.guaranty': 'Garancia',
    'menu.property.sales.new.engineering': 'Inxhinieri',
    'menu.agency-liability': 'Pergjegjesi Agjensie',
    'menu.professional-architect-engineer': 'Profesionale Arkitekt & Inxhinier',
    'menu.property.sales.new.banking': 'Banka',
    'menu.property.sales.new.agricultural': 'Bujqësore',
    'menu.property.sales.new.reinsurance': 'Risigurimi',
    'menu.livestock-insurance': 'Sigurimi i Bagëtive',
    'menu.crop-insurance': 'Sigurimi i Kulturave',
    'menu.greenhouse-insurance': 'Sigurimi i Serave',
    'menu.device-insurance': 'Sigurimi i Pajisjeve',
    'menu.property.sales.list': 'Listë',
    'menu.property.sales.lista-e-drafteve': 'Lista e drafteve',
    'menu.property.configurations.banks': 'Bankat',
    'menu.public-accommodating-structures': 'Strukturat Publike të Akomodimit',
    'menu.public-property-under-pressure-liability': 'Pergjegjesi Publike e Eneve Nen Presion',
    'menu.public-neighbor-liability': 'Pergjegjesi Publike Ligjore Karshi Fqinjit',
    'menu.professional-doctor-liability': 'Pergjegjesi Profesionale Per Mjek',

    'menu.professional-broker-liability': 'Pergjegjesi Profesionale e Brokerave',
    'menu.professional-lawyer-liability': 'Pergjegjesi Profesionale e Avokateve',
    'menu.professional-enforcement-officer-liability': 'Pergjegjesi Profesionale e Permbaruesit Gjygjesor',
    'menu.public-third-party-liability': 'Pergjegjesi Publike Ndaj Paleve te Treta',
    'menu.public-product-employer-liability': 'Pergjegjesi Publike GTPL&PL&EL',
    'menu.professional-real-estate-appraiser-liability': 'Pergjegjesi E Pasurive Te Paluajtshme',

    'menu.professional-loss-assessor-liability': 'Pergjegjesi Profesionale Vlersues Demes',

    'menu.liability': 'Përgjegjësia',

    'menu.property.claims': 'Pretendimet',
    'menu.property.claims.new': 'Praktikë e re',
    'menu.property.claims.list': 'Lista e kërkesave',
    'menu.property.claims.list-events': 'Lista e ngjarjeve',
    'menu.property.configurations': 'Konfigurimet',
    'menu.property.configurations.fleets': 'Flotat',

    'menu.fire': 'Zjarri',
    'menu.guaranty': 'Garancia',
    'menu.public': 'Publike',

    'menu.health': 'Shëndeti',
    'menu.health.sales': 'Shitjet',
    'menu.health.sales.new': 'Shitjet e reja',
    'menu.health.sales.list': 'Listë',
    'menu.health.sales.lista-e-drafteve': 'Lista e drafteve',
    'menu.health.claims': 'Pretendimet',
    'menu.health.claims.new': 'Praktikë e re',
    'menu.health.claims.list': 'Lista e kërkesave',
    'menu.health.claims.list-events': 'Lista e ngjarjeve',
    'menu.health.configurations': 'Konfigurimet',
    'menu.health.configurations.fleets': 'Flotat',
    'menu.private': 'Shëndeti privat',
    'menu.telehealth': 'Teleshendet',
    'menu.motor.configurations.list': 'Lista ADE',
    'menu.travel': 'Shëndet në udhëtim',
    'menu.antitumor': 'Antitumor',
    'menu.life-plus': 'Jete Plus',
    'menu.travel-embassy': 'Shëndet në udhëtim (Ambasade)',

    'menu.marine': 'Marine',
    'menu.marine.sales': 'Shitjet',
    'menu.marine.sales.new': 'Shitjet e reja',
    'menu.marine.sales.list': 'Listë',
    'menu.marine.sales.lista-e-drafteve': 'Lista e drafteve',
    'menu.marine.sales.duplicate': 'Dublikate',
    'menu.marine.claims': 'Pretendimet',
    'menu.marine.claims.new': 'Praktikë e re',
    'menu.marine.claims.list': 'Lista e kërkesave',
    'menu.marine.claims.list-events': 'Lista e ngjarjeve',
    'menu.marine.configurations': 'Konfigurimet',
    'menu.marine.configurations.fleets': 'Flotat',
    'menu.finance': 'Financa',
    'menu.finance.reconciliation': 'Arkëtime',
    'menu.finance.reconciliation.new': 'Arkëtim i ri',
    'menu.finance.reconciliation.list': 'Lista e arkëtimeve',
    'menu.finance.reports': 'Raportet',
    'menu.finance.reports.daily': 'E përditshme',
    'menu.finance.reports.monthly': 'Mujore',
    'menu.finance.reports.yearly': 'vjetore',
    'menu.finance.reports.custom': 'Dinamike',
    'menu.finance.invoices': 'Faturat',
    'menu.finance.bankAccount': 'Llogarite Bankare',
    'menu.contacts': 'Kontaktet',
    'menu.contacts.all': 'Të gjitha',
    'menu.contacts.customers': 'Klientët',
    'menu.contacts.agencies': 'Agjencitë',
    'menu.contacts.branches': 'Degët',
    'menu.contacts.hospital': 'Spitalet',
    'menu.contacts.intermediaries': 'Ndërmjetës',
    'menu.contacts.underwriters': 'Nënshkruesit',
    'menu.contacts.insurers': 'Siguruesit',
    'menu.catalog': 'Katalog',
    'menu.catalog.products': 'Produkte',
    'menu.catalog.blocked-objects': 'Objektet e Bllokuara',
    'menu.catalog.communication-exclusions': 'Përjashtimet e Komunikimit',
    'menu.catalog.configurations': 'Konfigurimet',
    'menu.catalog.template': 'Model',
    'menu.auth0': 'Auth0',
    'menu.auth0.users': 'Përdoruesit',
    'menu.auth0.roles': 'Rolet',
    'menu.auth0.permissions': 'Akseset',
    'menu.map': 'Hartë',
    'menu.map.albania': 'Shqipëria',
    'menu.exception.403': '403',
    'menu.exception.404': '404',
    'menu.exception.500': '500',
    'menu.form': 'Forma',
    'menu.form.basic-form': 'Formulari bazë',
    'menu.form.step-form': 'Formulari i hapit',
    'menu.form.step-form.info': 'Formulari i hapit (shkruani informacionin e transferimit)',
    'menu.form.step-form.confirm': 'Formulari i hapit (konfirmoni informacionin e transferimit)',
    'menu.form.step-form.result': 'Formulari i hapit (përfundoi)',
    'menu.form.advanced-form': 'Formulari i avancuar',
    'menu.list': 'Listë',
    'menu.list.table-list': 'Tabela e kërkimit',
    'menu.list.basic-list': 'Lista bazë',
    'menu.list.card-list': 'Lista e kartave',
    'menu.list.search-list': 'Lista e kërkimit',
    'menu.list.search-list.articles': 'Lista e kërkimit (artikuj)',
    'menu.list.search-list.projects': 'Lista e kërkimit (projektet)',
    'menu.list.search-list.applications': 'Lista e kërkimit (aplikacionet)',
    'menu.profile': 'Profili',
    'menu.profile.basic': 'Profili bazë',
    'menu.profile.advanced': 'Profili i avancuar',
    'menu.result': 'Rezultati',
    'menu.result.success': 'Sukses',
    'menu.result.fail': 'Dështoni',
    'menu.exception': 'Përjashtim',
    'menu.exception.not-permission': '403',
    'menu.exception.not-find': '404',
    'menu.exception.server-error': '500',
    'menu.exception.trigger': 'Shkasë',
    'menu.account': 'Llogaria',
    'menu.account.center': 'Qendra e llogarisë',
    'menu.account.settings': 'Cilësimet e llogarisë',
    'menu.account.trigger': 'Gabimi i nxitjes',
    'menu.account.logout': 'Shkyç',
    'menu.editor': 'Redaktori grafik',
    'menu.editor.flow': 'Redaktori i rrjedhës',
    'menu.editor.mind': 'Redaktori i mendjes',
    'menu.editor.koni': 'Koni Redaktor',

    'menu.public-liability': 'Përgjegjësia Publike',
    'menu.product-liability': 'Përgjegjësia e Produktit',
    'menu.professional-liability': 'Përgjegjësia Profesionale',
    'menu.employer-liability': 'Përgjegjësia e Punëdhënësit',
    'menu.pollution-liability': 'Përgjegjësia e Ndotjes',
    'menu.other-liability': 'Përgjegjësia të Tjera',
    'menu.builder-liability-650': 'Përgjegjësia e Ndërtuesit (VKM 650)',
    'menu.notary': 'Noter',
    'menu.builder-liability-693': 'Përgjegjësia e Ndërtuesit (VKM 693)',
    'menu.fuel-liability': 'Përgjegjësia e Karburantit',
    'menu.directors-and-officers-liability': 'Përgjegjësia e Drejtorëve dhe Zyrtarëve',
    'menu.cyber': 'Përgjegjësia Cyber',
    'menu.do': 'Përgjegjësia D&O',
    'menu.cit': 'Sigurimi i Mallit ne Transport',
    'menu.cash-vault': 'Siguracioni Para Ne Kasaforte',

    'menu.finance.reconciliation.invoices': 'Faturat',
    'menu.finance.failedInvoices': 'Faturat e dështuara',

    'menu.professional-liability-873/610': 'Përgjegjësia Profesionale (VKM 873/610)',
    'menu.public-liability-873': 'Përgjegjësia Publike (VKM 873)',
    'menu.professional-insurance-agent': 'Përgjegjësia Profesionale e Agjentëve te Sigurimit',
    'menu.catalog.single': 'Single',

    'menu.contract-guaranty': 'Garancia e kontratës',
    'menu.licensing-guaranty': 'Garancia e licenses',
    'menu.prepaid-guaranty': 'GARANCI PARADHENJE',
    'menu.rent-guaranty': 'GARANCI QERAJE',
    'menu.judicial-guaranty': 'GARANCI GJYQESORE',
    'menu.bank-guaranty': 'KUNDERGARANCI ME BANKAT',
    'menu.offer-guaranty': 'Garancia e Ofertës',

    'menu.motor.configurations.vehicles': 'Mjetet',
    'pages.motor.Vehicles': 'Mjetet',
    'pages.motor.Add Vehicle': 'Shto mjetet',

    'menu.daily-autosos': 'Autosos ditor',
    'menu.travel-albania': 'Shëndet në udhëtim Shqipëri',

    'menu.claims': 'Demet',
    'menu.claims.specialists': 'Specialistet',
    'menu.claims.list': 'Lista e demeve',

    'menu.driver-accidents': 'Driver Accidents',
    'menu.personal-accidents': 'Personal Accidents',
    'menu.property.configurations.cities': 'Qytetet',
    'menu.motor.sales.duplicate': 'Dublikate',

    'menu.quality-guaranty': 'Garanci Cilësie',
    'menu.maintenance-guaranty': 'Garanci Mirëmbajtje',
    'menu.customs-guaranty': 'Garanci Agjensi Doganore',
    'menu.customs-warehouse-guaranty': 'Garanci Magazinë Doganore',
    'menu.excise-tax-guaranty': 'Garanci Akcize',
    'menu.excise-tax-other-import-guaranty': 'Garanci Akcize Tjeter (Import)',
    'menu.iata-guaranty': 'Garanci Eksport i Jashtëm (IATA)',
    'menu.building-permit-guaranty': 'Garanci Leje Ndërtimi',
    'menu.waste-removal-guaranty': 'Garanci Heqje Mbeturinash Pas Ndërtimi',
    'menu.payment-guaranty': 'Garanci Pagese',
    'menu.concession-request-guaranty': 'Garanci Kërkesë Për Koncesion',
    'menu.employers-liability': 'Pergjegjesi Publike e Punedhenesit',
    'menu.contacts.broker': 'Broker',
    'menu.motor.configurations.register': 'Regjistro ne ADE',
    'menu.professional-hiring-agency-liability': 'Pergjegjesi Profesionale E Agjensive Te Punesimit (Vkm 703)',
    'menu.finance.balance': 'Balancat',
    'menu.finance.payments': 'Pagesat',
    'menu.import': 'Policat e paimportuara',
    'menu.policy-renewals': 'Rinovime',
    'menu.travel-plus': 'Travel Plus',
    'menu.tasks': 'Tasks',
};
